// Collects every var name a playbook can write: item.set, the set and inc keys of options and transitions,
// and the declared captures. Used to drive autocomplete in the editor: not a validator, just a best-effort list
export function collectVars(playbook: Playbook): string[] {
  const names = new Set<string>()
  for (const { items } of Object.values(playbook.flows || {})) {
    for (const item of items || []) for (const name of itemWrites(item)) names.add(name)
  }
  return [...names].sort()
}

export function itemWrites(item: PlaybookItem): string[] {
  const names: string[] = []
  if (item.set) names.push(item.set)
  for (const capture of item.captures || []) if (capture.var) names.push(capture.var)
  for (const writer of [...item.options || [], ...item.transitions || []]) names.push(...Object.keys(writer.set || {}), ...Object.keys(writer.inc || {}))
  return names
}

// The paths of PlaybookGlobals, for autocomplete and so the validator does not ask who writes them
export const GLOBAL_VARS = ["global.lastMessage", "global.messageCount"]

export function isGlobal(name: string) {
  return name === "global" || name.startsWith("global.")
}

// Best effort: vars come from what the contact typed, from literals and from the model, so the operator decides the type
// and the value is read as that type whenever it can be. undefined means it cannot
const TRUE = new Set(["true", "yes", "y", "si", "sí", "oui", "on", "ok"])
const FALSE = new Set(["false", "no", "n", "non", "off"])

export function toNumber(value: any): number | undefined {
  if (typeof value === "number") return Number.isFinite(value) ? value : undefined
  if (typeof value === "boolean") return value ? 1 : 0
  if (typeof value !== "string") return undefined
  const found = value.match(/-?\d+(?:[.,]\d+)?/)
  return found ? Number(found[0].replace(",", ".")) : undefined
}

export function toBoolean(value: any): boolean | undefined {
  if (typeof value === "boolean") return value
  if (typeof value === "number") return value > 0
  if (typeof value !== "string") return undefined
  const text = value.trim().toLowerCase()
  if (TRUE.has(text)) return true
  if (FALSE.has(text)) return false
  const number = /^-?\d+(?:[.,]\d+)?$/.test(text) ? toNumber(text) : undefined
  return number === undefined ? undefined : number > 0
}
